(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[219],{

/***/ 9258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pages__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6724);
/* harmony import */ var _data_menu_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4828);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5215);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);







const Slug = () => {
  const {
    state,
    dispatch
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_4__/* .Context */ ._);
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  const {
    0: slug,
    1: setSlug
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_data_menu_data__WEBPACK_IMPORTED_MODULE_3__/* .dataMenuLabels */ .SC)()[0]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var _router$query;

    const checkSlug = router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.slug;

    if (checkSlug) {
      const foundLabel = (0,_data_menu_data__WEBPACK_IMPORTED_MODULE_3__/* .dataMenuLabels */ .SC)().find(v => v.slug === checkSlug);
      if (foundLabel) setSlug(foundLabel);
    }
  }, [router]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(pages__WEBPACK_IMPORTED_MODULE_2__["default"], {
    navRef: slug
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Slug);

/***/ }),

/***/ 9104:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(9258);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [191,990,724,774,888,179], function() { return __webpack_exec__(9104); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);